import React from 'react'
import { Switch } from 'react-router-dom'
import { Route } from 'utils'
import { urls } from 'urls'
import {
  AnonymousLayout,
  SigninCallbackPage,
  SilentSigninCallbackPage,
  LoginPage,
  LogoutPage,
  SuppliersListPage, SuppliersDetailPage,
  OrdersListPage, OrdersDetailPage, DeletedOrdersListPage,
  OrderProcessingPage, OrderProcessingDetailPage,
  OrderSelectorPage,
  DashboardPage,
  ReleaseNotesListPage,
  LookupSelectorPage,
  GrapesListPage, GrapesDetailPage,
  ProducersListPage, ProducersDetailPage,
  CurrenciesListPage, CurrenciesDetailPage,
  WineStylesListPage, WineStylesDetailPage,
  EvaluatorsListPage, EvaluatorsDetailPage,
  WineTypesListPage, WineTypesDetailPage,
  ClassificationByOriginsListPage, ClassificationByOriginsDetailPage,
  ClassificationByParamsesListPage, ClassificationByParamsesDetailPage,
  FlavourCharacteristicsesListPage, FlavourCharacteristicsesDetailPage,
  VineyardStylesListPage, VineyardStylesDetailPage,
  ProduceStylesListPage, ProduceStylesDetailPage,
  StoragePlacesListPage, StoragePlacesDetailPage,
  RegionsListPage, RegionsDetailPage,
  CountriesListPage, CountriesDetailPage,
  DistrictsListPage, DistrictsDetailPage,
  SubdistrictsListPage, SubdistrictsDetailPage,
  WinesListPage, WinesDetailPage,
  BottlesListPage, DeletedBottlesListPage, BottlesDetailPage,
  BottlesSimpleListPage, BottlesSimpleDetailPage,
  WinesInStockPage
} from 'pages'
import { constants } from 'consts'

export default (
  <Switch>
    <Route component={LookupSelectorPage} path={urls.lookups.base} exact />
    <Route component={OrderSelectorPage} path={urls.orders.base} exact />
    
    <Route component={WinesInStockPage} path={urls.winesInStock.base} exact />

    <Route component={SuppliersListPage} path={urls.suppliers.base} exact />
    <Route component={SuppliersDetailPage} path={urls.suppliers.detail} exact />

    <Route component={OrdersListPage} path={urls.orderList.base} exact />
    <Route component={OrdersDetailPage} path={urls.orderList.detail} exact />
    <Route component={DeletedOrdersListPage} path={urls.orderList.trash} exact />
    
    <Route component={OrderProcessingPage} path={urls.orderProcessing.base} exact />
    <Route component={OrderProcessingDetailPage} path={urls.orderProcessing.detail} exact />

    <Route component={GrapesListPage} path={urls.grapes.base} exact />
    <Route component={GrapesDetailPage} path={urls.grapes.detail} exact />

    <Route component={VineyardStylesListPage} path={urls.vineyardStyles.base} exact />
    <Route component={VineyardStylesDetailPage} path={urls.vineyardStyles.detail} exact />

    <Route component={ProduceStylesListPage} path={urls.produceStyles.base} exact />
    <Route component={ProduceStylesDetailPage} path={urls.produceStyles.detail} exact />

    <Route component={BottlesListPage} path={urls.bottles.base} exact />
    <Route component={BottlesDetailPage} path={urls.bottles.detail} exact />
    <Route component={DeletedBottlesListPage} path={urls.bottles.trash} exact />

    <Route component={BottlesSimpleListPage} path={urls.bottlesSimple.base} exact />
    <Route component={BottlesSimpleDetailPage} path={urls.bottlesSimple.detail} exact />

    <Route component={ProducersListPage} path={urls.producers.base} exact />
    <Route component={ProducersDetailPage} path={urls.producers.detail} exact />

    <Route component={CurrenciesListPage} path={urls.currencies.base} exact />
    <Route component={CurrenciesDetailPage} path={urls.currencies.detail} exact />

    <Route component={WinesListPage} path={urls.wines.base} exact />
    <Route component={WinesDetailPage} path={urls.wines.detail} exact />

    <Route component={WineStylesListPage} path={urls.wineStyles.base} exact />
    <Route component={WineStylesDetailPage} path={urls.wineStyles.detail} exact />

    <Route component={EvaluatorsListPage} path={urls.evaluators.base} exact />
    <Route component={EvaluatorsDetailPage} path={urls.evaluators.detail} exact />

    <Route component={WineTypesListPage} path={urls.wineTypes.base} exact />
    <Route component={WineTypesDetailPage} path={urls.wineTypes.detail} exact />

    <Route component={ClassificationByOriginsListPage} path={urls.classificationByOrigins.base} exact />
    <Route component={ClassificationByOriginsDetailPage} path={urls.classificationByOrigins.detail} exact />

    <Route component={ClassificationByParamsesListPage} path={urls.classificationByParamses.base} exact />
    <Route component={ClassificationByParamsesDetailPage} path={urls.classificationByParamses.detail} exact />

    <Route component={FlavourCharacteristicsesListPage} path={urls.flavourCharacteristicses.base} exact />
    <Route component={FlavourCharacteristicsesDetailPage} path={urls.flavourCharacteristicses.detail} exact />

    <Route component={StoragePlacesListPage} path={urls.storagePlaces.base} exact />
    <Route component={StoragePlacesDetailPage} path={urls.storagePlaces.detail} exact />
    
    <Route component={RegionsListPage} path={urls.regions.base} exact />
    <Route component={RegionsDetailPage} path={urls.regions.detail} exact />
    <Route component={CountriesListPage} path={urls.countries.base} exact />
    <Route component={CountriesDetailPage} path={urls.countries.detail} exact />
    <Route component={DistrictsListPage} path={urls.districts.base} exact />
    <Route component={DistrictsDetailPage} path={urls.districts.detail} exact />
    <Route component={SubdistrictsListPage} path={urls.subdistricts.base} exact />
    <Route component={SubdistrictsDetailPage} path={urls.subdistricts.detail} exact />

    <Route component={ReleaseNotesListPage} exact path={urls.releaseNotes.base} />

    <Route layout={AnonymousLayout} component={LoginPage} exact path={urls.login.base} />
    <Route layout={AnonymousLayout} component={LogoutPage} exact path={urls.logout.base} />
    <Route layout={AnonymousLayout} component={SigninCallbackPage} exact path={constants.authentication.SIGNIN_CALLBACK} />
    <Route layout={AnonymousLayout} component={SilentSigninCallbackPage} exact path={constants.authentication.SILENT_SIGNIN_CALLBACK} />
    <Route component={DashboardPage} path={urls.dashboard.base} exact />
  </Switch>
)
